export const ID = {
    translations: {
        notifications: 'Notifikasi',
        markAllAsRead: 'Tandai semua sudah dibaca',
        poweredBy: 'Dipersembahkan Oleh',
        settings: 'Pengaturan',
        noNewNotification: 'Belum ada yang baru untuk dilihat di sini',
    },
    lang: 'id',
};
//# sourceMappingURL=id.js.map